import React from 'react';
import ReactDOM from 'react-dom';
import { VideoDetailLikesModalProps } from './types';
import { toRelativePath } from '../../utils/videoImagePath';
import styles from './VideoDetailLikesModal.module.css';

/**
 * いいねしたユーザー一覧モーダル
 */
export const VideoDetailLikesModal: React.FC<VideoDetailLikesModalProps> = ({ 
  likers, 
  onClose 
}) => {
  // モーダルの内容
  const modalContent = (
    <div 
      className={styles['video-detail-likes-modal-dialog-overlay']} 
      onClick={onClose}
      data-testid="video-detail-likes-modal"
    >
      <div 
        className={styles['video-detail-likes-modal-dialog']} 
        onClick={(e) => e.stopPropagation()}
      >
        <h2>いいねした人一覧</h2>
        {likers.length === 0 && <p>誰もいいねしていません。</p>}
        {likers.map((user) => (
          <div 
            key={user.id} 
            className={styles['video-detail-likes-modal-liker-row']}
            data-testid="video-detail-likes-modal__liker-row"
          >
            <img
              src={
                user.icon_path
                  ? toRelativePath(user.icon_path)
                  : '/asset/no_icon_user.png'
              }
              alt="Liker Icon"
              className={styles['video-detail-likes-modal-liker-icon']}
            />
            <span>{user.name}</span>
          </div>
        ))}
        <button 
          className={styles['video-detail-likes-modal-close-button']} 
          onClick={onClose}
          data-testid="video-detail-likes-modal__close-button"
        >
          閉じる
        </button>
      </div>
    </div>
  );

  // body要素の直下にReactPortalでレンダリング
  return ReactDOM.createPortal(
    modalContent,
    document.body
  );
};

export default VideoDetailLikesModal; 